@if ((useLazyLoad && !isLoaded) || (data()?.push)) {
  <sd-push-card-banner
    [sdSpyTarget]="componentUid"
    (clicked)="onClick($event)"
    (carouselClicked)="onCarouselClicked($event)"
    [brand]="brandCorner"
    [isLoading]="useLazyLoad && !isLoaded"
    [isFit]="false"
    [data]="data()"
  />
}
